import {
  Box,
  Button,
  Modal,
  Typography,
  Pagination,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import React, { useEffect, useState } from "react";
// import { biasAssessment } from "../../services/apiCalls";

import BiasAlertsJSON from "../../bias_assesment_files/json_with_bias_alerts_full_users.json";

const ITEMS_PER_PAGE = 5;

const BiasAssessment = ({ open, handleClose }) => {
  const style = {
    display: "flex",
    flexDirection: "column",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  // const [assessment, setAssessment] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const alertsJson = BiasAlertsJSON.bias_analysis.alerts;

  // console.log("Alertsjson: ", alertsJson);
  // TODO: connect with kafka via websockets

  // useEffect(() => {
  //   const fetchAssessment = async () => {
  //     try {
  //       const assessments = await biasAssessment();
  //       const mdrsAssessment = assessments.find(
  //         (assessment) => assessment.collection_name === "MDRS_APPO_assessment"
  //       );
  //       if (mdrsAssessment) {
  //         setAssessment(mdrsAssessment);
  //       } else {
  //         console.log("No assessment was found for this dataset");
  //       }
  //     } catch (error) {
  //       console.log("Error fetching assessments:", error);
  //     }
  //   };
  //   fetchAssessment();
  // }, []);

  // const formatAlerts = (alerts) => {
  //   return alerts.map((alert) => {
  //     const [field, message] = alert.split("]");
  //     return `${field.slice(1)}: ${message.trim()}`;
  //   });
  // };

  // Pagination Logic
  const totalPages = Math.ceil(alertsJson.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;
  const paginatedData = alertsJson.slice(startIndex, endIndex);

  const handlePageChange = (e, value) => {
    setCurrentPage(value);
  };

  const handleDownloadPDF = () => {
    setLoading(true);
    setTimeout(() => {
      const link = document.createElement("a");
      link.href = "/users_appo_report.pdf";
      link.setAttribute("download", "bias_report.pdf");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setLoading(false);
    }, 2000);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Bias Assessment Results
        </Typography>
        {alertsJson.length > 0 ? (
          <>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              Here are the alerts for the assessment:
            </Typography>
            <ul>
              {paginatedData.map((alert, index) => (
                <li key={index}>
                  <Typography variant="body2">{alert}</Typography>
                </li>
              ))}
            </ul>
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={handlePageChange}
              color="primary"
              sx={{ display: "flex", justifyContent: "center", mt: 4, mb: 4 }}
            />
          </>
        ) : (
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            No alerts found for this assessment.
          </Typography>
        )}
        <Button
          onClick={handleDownloadPDF}
          disabled={loading}
          sx={{ textAlign: "center", alignItems: "center" }}
        >
          {loading ? (
            <Backdrop
              sx={{
                color: "#fff",
                zIndex: (theme) => theme.zIndex.drawer + 1,
              }}
              open={loading}
            >
              <CircularProgress size={24} color="inherit" />
            </Backdrop>
          ) : (
            "Download bias assessment file for more info"
          )}
        </Button>
      </Box>
    </Modal>
  );
};

export default BiasAssessment;
